import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { StockRegisterProvider } from '../centerWarehouse/stockRegister/ContextAPI';
import Index from '../centerWarehouse/stockRegister/Index';
import PermissionDenied from './PermissionDenied';

export default function CenterStockRegister() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['center-stock-register']) return <PermissionDenied />;

    return (
        <StockRegisterProvider>
            <Index />
        </StockRegisterProvider>
    );
}
